/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "common": {
            "nested": {
              "TenderType": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "PAY_WITH_SQUARE": 1,
                  "KEYED_CARD": 2,
                  "SWIPED_CARD": 3,
                  "BILL": 4,
                  "RECORDED": 5,
                  "BILL_V2": 6,
                  "EMV_CONTACT_CARD": 7,
                  "CONTACTLESS_CARD": 8,
                  "BALANCE_PAYMENT": 9,
                  "SERVER_COMPLETED": 10,
                  "FELICA_CONTACTLESS": 11,
                  "BANK": 15,
                  "CARD_ON_FILE": 16,
                  "ASYNC_TRANSACTION": 17
                }
              },
              "MessageType": {
                "values": {
                  "NONE": 0,
                  "DUAL_MESSAGE_PURCHASE": 1,
                  "DUAL_MESSAGE_OFFLINE_APPROVED_PURCHASE": 8,
                  "DUAL_MESSAGE_UNLINKED_REFUND": 2,
                  "SINGLE_MESSAGE_PURCHASE": 3,
                  "DUAL_MESSAGE_AFT": 4,
                  "SINGLE_MESSAGE_OCT": 5,
                  "VERIFICATION": 6,
                  "SINGLE_MESSAGE_PUSH": 7,
                  "DUAL_MESSAGE_PUSH": 9
                }
              },
              "CvvStatus": {
                "values": {
                  "DEFAULT_CVV_STATUS_ENUM_DO_NOT_USE": 0,
                  "CVV_ACCEPTED": 1,
                  "CVV_REJECTED": 2,
                  "CVV_NOT_CHECKED": 3
                }
              },
              "AvsStatus": {
                "values": {
                  "DEFAULT_AVS_STATUS_ENUM_DO_NOT_USE": 0,
                  "AVS_ACCEPTED": 1,
                  "AVS_REJECTED": 2,
                  "AVS_NOT_CHECKED": 3
                }
              },
              "LuhnStatus": {
                "values": {
                  "DEFAULT_LUHN_STATUS_ENUM_DO_NOT_USE": 0,
                  "PASSED": 1,
                  "FAILED": 2,
                  "SKIPPED": 3
                }
              },
              "InternalAccountType": {
                "values": {
                  "DEFAULT_ACCOUNT_TYPE_DO_NOT_USE": 0,
                  "OTHER": 1,
                  "CARD_ACCOUNT": 2,
                  "WALLET_ID": 3
                }
              },
              "PaymentAccountInfo": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "internalAccountIdentifier": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "internalAccountType": {
                    "type": "squareup.payments.common.InternalAccountType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 7,
                    "rule": "optional"
                  },
                  "birthDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "CardNetwork": {
                "values": {
                  "DEFAULT_CARD_NETWORK_DO_NOT_USE": 0,
                  "AMEX_NETWORK": 1,
                  "UNION_PAY_NETWORK": 2,
                  "DISCOVER_NETWORK": 3,
                  "EFTPOS_NETWORK": 4,
                  "INTERAC_NETWORK": 5,
                  "MAESTRO_NETWORK": 6,
                  "MASTERCARD_NETWORK": 7,
                  "NYCE_NETWORK": 8,
                  "PULSE_NETWORK": 9,
                  "VISA_NETWORK": 10,
                  "UNKNOWN_NETWORK": 11,
                  "SIMULATOR_NETWORK": 12
                }
              },
              "AcquiringEntity": {
                "values": {
                  "DEFAULT_ACQUIRING_NETWORK_DO_NOT_USE": 0,
                  "ADYEN": 1,
                  "AMEX": 2,
                  "BANCORP": 3,
                  "CHASE": 4,
                  "CUSCAL": 5,
                  "EVERLINK": 6,
                  "JCB": 7,
                  "SHAZAM": 8,
                  "SMCC": 9,
                  "SQUARE": 10,
                  "SUTTON": 11,
                  "SIMULATOR": 12
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.TenderType && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.MessageType && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.CvvStatus && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.AvsStatus && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.LuhnStatus && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.InternalAccountType && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.PaymentAccountInfo && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.CardNetwork && !$root.nested?.squareup?.nested?.payments?.nested?.common?.nested?.AcquiringEntity) {
  $root.addJSON(jsonData);
}

/**
 * Type of tender used for a given transaction.
 *
 * SOURCE TenderType @ squareup/payments/common.proto at 12:1
 */
export const TenderType = $root.lookupEnum('squareup.payments.common.TenderType').values;
/**
 * Message type.
 *
 * SOURCE MessageType @ squareup/payments/common.proto at 61:1
 */
export const MessageType = $root.lookupEnum('squareup.payments.common.MessageType').values;
/**
 * A status that is commonly used to indicate the outcome of a CVV
 * check, often found in many Payments related RPCs.
 *
 * SOURCE CvvStatus @ squareup/payments/common.proto at 272:1
 */
export const CvvStatus = $root.lookupEnum('squareup.payments.common.CvvStatus').values;
/**
 * A status that is commonly used to indicate the outcome of an AVS
 * check, often found in many Payments related RPCs.
 *
 * SOURCE AvsStatus @ squareup/payments/common.proto at 288:1
 */
export const AvsStatus = $root.lookupEnum('squareup.payments.common.AvsStatus').values;
/**
 * The status of a Luhn check.
 *
 * SOURCE LuhnStatus @ squareup/payments/common.proto at 303:1
 */
export const LuhnStatus = $root.lookupEnum('squareup.payments.common.LuhnStatus').values;
/**
 * SOURCE InternalAccountType @ squareup/payments/common.proto at 349:1
 */
export const InternalAccountType = $root.lookupEnum('squareup.payments.common.InternalAccountType').values;
/**
 * A party involved in a Peer to Peer payment (personal or commercial), not a merchant.
 * Meant to be more general than SenderInfo.
 *
 * SOURCE PaymentAccountInfo @ squareup/payments/common.proto at 358:1
 */
export const PaymentAccountInfo = $root.lookupType('squareup.payments.common.PaymentAccountInfo');
fixType(PaymentAccountInfo);
Builder.createAndAttachToType(PaymentAccountInfo);
/**
 * The external network that processed the transaction. For credit transactions, this will
 * typically be the network of the brand on the front of the card. For debit, it could be any one
 * of the debit networks that the card supports.
 *
 * SOURCE CardNetwork @ squareup/payments/common.proto at 378:1
 */
export const CardNetwork = $root.lookupEnum('squareup.payments.common.CardNetwork').values;
/**
 * The entity (a financial institution, which is typically, but not strictly, a bank) that serves
 * as the acquirer for a given transaction. Selection can be driven by the client, gateway, or
 * routing layer. Not applicable to all gateways or transaction types.
 *
 * SOURCE AcquiringEntity @ squareup/payments/common.proto at 406:1
 */
export const AcquiringEntity = $root.lookupEnum('squareup.payments.common.AcquiringEntity').values;